module.exports = __webpack_public_path__ + "static/img/bottom_left_icon.5773eb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom_left_icon.png
// module id = BQ5+
// module chunks = 1